<template>
    <hts-modal
        v-model="visible"
        title="Mở khai thác"
        @close="resetFields">
        <template #custom>
            <p class="font-bold">
                Sau khi mở khai thác, xe được xem là đủ năng lực vận chuyển và đưa vào danh sách điều phối. Vui lòng xác nhận.
            </p>

            <div class="flex mt-5 justify-end">
                <hts-form-button
                    color="primary"
                    type="submit"
                    :loading="false"
                    @click="submit">
                    Xác nhận
                </hts-form-button>

                <hts-form-button
                    class="pl-2"
                    color="error"
                    @click="close">
                    {{ $t('labels.cancel') }}
                </hts-form-button>
            </div>
        </template>
    </hts-modal>
</template>

<script setup lang="ts">
const emits = defineEmits(['refreshTables'])

const visible = ref(false)
const vehicleId = ref('')

const close = () => {
  resetFields()
  visible.value = false
}

const open = (id: string) => {
  vehicleId.value = id
  visible.value = true
}

const resetFields = () => {
  vehicleId.value = ''
}

const submit = async () => {
  const api = $url.vehicle.vehicle.openExploit

  const data: any = await $api(api, {
    uriParams: { ID: vehicleId.value }
  })

  const resData = data?.data?.value
  if (resData?.success) {
    emits('refreshTables')
    process.client && $toast().success($t('labels.openExploitSuccess'))
    close()
  }
}

defineExpose({ open })
</script>
